import { getChromeMajorVersion } from "react-lib/utils/chromeVersion";

// ตำแหน่งบนจอจริงของ element ที่อยู่ใต้ CSS zoom ไม่ขึ้นกับ container ที่ scroll

// zoom สะสมของ element และ ancestor ทั้งหมด
export const getEffectiveZoom = (el: Element | null) => {
  let zoom = 1;
  let node: Element | null = el;

  while (node && node !== document.documentElement) {
    const value = Number.parseFloat(window.getComputedStyle(node).getPropertyValue("zoom"));

    if (value && !Number.isNaN(value)) {
      zoom *= value;
    }

    node = node.parentElement;
  }

  return zoom;
};

// Chrome < 125 คืนค่า getBoundingClientRect ของ element ใต้ CSS zoom เป็นพิกัดก่อน zoom (issue 52820)
const isLegacyZoomRect = () => {
  const version = getChromeMajorVersion();

  return version > 0 && version < 125;
};

// ตำแหน่ง/ขนาดของ element ในพิกัดเดียวกับ MouseEvent.clientX / clientY
export const getViewportRect = (el: Element) => {
  const rect = el.getBoundingClientRect();
  const k = isLegacyZoomRect() ? getEffectiveZoom(el) : 1;

  return { left: rect.left * k, top: rect.top * k, width: rect.width * k, height: rect.height * k };
};
